import {Component, OnDestroy, OnInit} from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DateModel, TaxFormCountries} from '../../../models/tax-forms.model';
import {select, Store} from '@ngrx/store';
import {TaxFormsState} from '../../../store/reducers/tax-forms.reducers';
import {SetDirtyCountrySelectionAction, SetTaxFormsCountriesAction} from '../../../store/actions/tax-forms.actions';
import {getTaxFormsSelectedCountries} from '../../../store/selectors/tax-forms.selectors';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-form-toolbar-countrylist-dialog',
  templateUrl: './form-toolbar-countrylist-dialog.component.html',
  styleUrls: ['./form-toolbar-countrylist-dialog.component.scss']
})
export class FormToolbarCountrylistDialogComponent implements OnInit , IDialogView, OnDestroy {
  filteredCountries: any[] = [];
  data: DialogModel;
  hasData: boolean = false;
  countries$: any;
  unsubscribe$ = new Subject<void>();
  countries: any[] = [];
  constructor(private taxFormsStore: Store<TaxFormsState>) { }

  ngOnInit() {
    this.countries$ = this.taxFormsStore.pipe(select(getTaxFormsSelectedCountries), takeUntil(this.unsubscribe$));
    this.countries$.subscribe(countries => {
      if (countries) {
        const updatedCountries = countries.map(country => {
          const synonyms = country.synonyms?.join('|') || '';
          return {
            ...country,
            countrySynonyms: synonyms
          };
        });

        this.filteredCountries = Object.assign([], updatedCountries);
        this.countries = Object.assign([], updatedCountries);
        this.hasData = true;
      }
    });
  }

  onOkClicked(): boolean {
    this.taxFormsStore.dispatch(new SetDirtyCountrySelectionAction(true));
    this.taxFormsStore.dispatch(new SetTaxFormsCountriesAction(this.countries));
    return true;
  }

  onFilterChange(countries) {
    this.countries = countries;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
